import { captureEvent } from "./capture_posthog_event";

export const CC_BCC_LOCATIONS = Object.freeze({
  BLAST: "blast",
  BULK: "bulk",
  CAMPAIGN: "campaign",
  DIRECT: "direct",
  INBOX: "inbox",
});

export const CC_BCC_SEND_MODES = Object.freeze({
  PER_MESSAGE: "per_message",
  PER_STEP: "per_step",
  PROOF_COPY: "proof_copy",
});

const normalizeRecipients = (recipients) => {
  if (!recipients) {
    return [];
  }

  const values = Array.isArray(recipients)
    ? recipients
    : String(recipients).split(/[,;\n]/);

  return values
    .map((recipient) => String(recipient).trim())
    .filter(Boolean)
    .filter(
      (recipient, index, all) =>
        all.findIndex(
          (candidate) => candidate.toLowerCase() === recipient.toLowerCase(),
        ) === index,
    );
};

const currentModule = () => {
  if (typeof GlobalContainer === "undefined") {
    return "unknown";
  }
  return GlobalContainer.product?.() || "unknown";
};

const normalizeModule = (module) => {
  if (module === "retention") {
    return "retention";
  }

  return "recruiting";
};

export const captureCcBccUsedEvent = ({
  location,
  module,
  sendMode,
  ccRecipients = [],
  bccRecipients = [],
}) => {
  const cc = normalizeRecipients(ccRecipients);
  const bcc = normalizeRecipients(bccRecipients);

  if (cc.length === 0 && bcc.length === 0) {
    return;
  }

  try {
    captureEvent("cc_bcc_used", {
      location,
      module: normalizeModule(module || currentModule()),
      send_mode: sendMode,
      has_cc: cc.length > 0,
      has_bcc: bcc.length > 0,
      cc_count: cc.length,
      bcc_count: bcc.length,
    });
  } catch (_error) {
    // Optional analytics must not turn a successful send/save into an error.
  }
};

export const captureCampaignCcBccUsedEvent = (campaign) => {
  if (!campaign?.new_engine) {
    return;
  }

  (campaign.campaign_steps_attributes || []).forEach((step) => {
    if (step._destroy || step.action_type !== "email") {
      return;
    }

    captureCcBccUsedEvent({
      location: CC_BCC_LOCATIONS.CAMPAIGN,
      sendMode: CC_BCC_SEND_MODES.PER_STEP,
      ccRecipients: step.cc_emails,
      bccRecipients: step.bcc_emails,
    });
  });
};
